module.exports = new __parcel__URL__("Solana.3c790cbc.svg").toString();